import script from "./AdRestrictedCategoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdRestrictedCategoryModal.vue?vue&type=script&setup=true&lang=js"

import "./AdRestrictedCategoryModal.vue?vue&type=style&index=0&id=5df84fda&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../../jump-dev-merge/서버/jump/jump-user/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df84fda"]])

export default __exports__